import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import * as Survey from "survey-react";
import Modal from "react-modal";
import axios from "axios";
import showdown from "showdown";
import ReCAPTCHA from "react-google-recaptcha";
import Loading from "./Loading/Loading";
import "survey-react/survey.css";
import "survey-react/modern.css";
import "../modal.scss";
Modal.setAppElement("#root");
const AppConfig = require("application-settings");
function Content() {
  const [sending, setSending] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [model, setModel] = useState(null);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [captchaExpired, setCaptchaExpired] = useState(false);
  const [languageCode, setLanguageCode] = useState("EN");
  const recaptchaRef = useRef();
  const converter = new showdown.Converter();
  const [totalFiles, setTotalFiles] = useState(0);
  const maxFileSize = 5 * 1024 * 1024;
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  let sumFiles = 0;
  const invalidFileRef = useRef(false);
  const [temporaryFilesStorage, setTemporaryFilesStorage] = useState([]);
  const [questions, setQuestions] = useState();
  const [fileValidating, setFileValidating] = useState(false);
  const [validatedFiles, setValidatedFiles] = useState([]);

  const validateFileOnBackend = async (file) => {
    try {
      setFileValidating(true);
      const base64 = await toBase64(file);
      const response = await axios.post(
        `${AppConfig.BaseUrl}/applicant/validate-pdf`,
        {
          content: base64,
          name: file.name,
          type: file.type,
        }
      );

      const isValid = response.data.valid;
      setFileValidating(false);
      return isValid;
    } catch {
      setFileValidating(false);
      return false;
    }
  };

  useEffect(() => {
    Survey.StylesManager.applyTheme("modern");
    setLanguageCode(checkLanguage(window.location.pathname));
    getJsonData();
    window.scrollTo(0, 0);
  }, []);
  const checkLanguage = (path) =>
    [
      "/automation",
      "/bilgiislem",
      "/teknisyen",
      "/tobacco",
      "/marketing",
      "/salesengineer",
      "/insankaynaklari",
      "/finansmuhasebe",
      "/kalitesurec",
    ].includes(path)
      ? "TR"
      : "EN";
  // Matris sorularında "isAllRowRequired" hatasının metni requiredErrorText'ten
  // değil, SurveyJS'in requiredInAllRowsError yerelleştirmesinden gelir. Locale
  // hiçbir yerde ayarlanmadığı için varsayılan İngilizce metni burada eziyoruz.
  const setMatrixRowErrorText = (surveyModel, language) =>
    surveyModel.onErrorCustomText.add((sender, options) => {
      if (options.name === "requiredinallrowserror") {
        options.text =
          language === "TR"
            ? "Lütfen tüm satırları cevaplayın!"
            : "Please answer every row!";
      }
    });
  const getJsonData = async () => {
    const pathName = window.location.pathname;
    setLanguageCode(checkLanguage(pathName));
    let questionFile = "";
    if (pathName === "/automation") {
      questionFile = "./automationquestions.json";
    } else if (pathName === "/bilgiislem") {
      questionFile = "./itquestions.json";
    } else if (pathName === "/teknisyen") {
      questionFile = "./technicianquestions.json";
    } else if (pathName === "/tobacco") {
      questionFile = "./tobacco.json";
    } else if (pathName === "/marketing") {
      questionFile = "./marketing.json";
    } else if (pathName === "/salesengineer") {
      questionFile = "./salesengineerquestions.json";
    } else if (pathName === "/insankaynaklari") {
      questionFile = "./hrquestions.json";
    } else if (pathName === "/finansmuhasebe") {
      questionFile = "./financeaccountingquestions.json";
    } else if (pathName === "/kalitesurec") {
      questionFile = "./qualityprocessquestions.json";
    } else {
      questionFile = "./questions.json";
    }
    try {
      const res = await axios.get(questionFile);
      const surveyModel = new Survey.Model({ questions: res.data.questions });
      setMatrixRowErrorText(surveyModel, checkLanguage(pathName));
      surveyModel.onValueChanged.add((sender, options) => {
        if (options.name === "uploadFiles") {
          let currentFiles = options.value || [];
          setTotalFiles(currentFiles.length);
          setTemporaryFilesStorage(currentFiles);
        }
      });
      surveyModel.onValueChanged.add((survey, options) => {
        if (options.name === "reference") {
          const referenceMatrix = survey.getQuestionByName("reference");
          referenceMatrix.visibleRows.forEach((row) => {
            const positionValue = row.getValue("reference_position");
            const contactValue = row.getValue("reference_contact");
            const referenceName = row.getValue("reference_name");

            row.getQuestionByColumnName("reference_name").isRequired =
              positionValue || contactValue ? true : false;
            row.getQuestionByColumnName("reference_contact").isRequired =
              referenceName ? true : false;
          });
        }
      });
      setModel(surveyModel);
      setQuestions(res.data.questions);
    } catch (error) {
      console.error("Error loading questions:", error);
    }
  };

  const axiosPost = async (answers) => {
    const pathName = window.location.pathname;
    let applicantType = "";
    if (pathName === "/automation") {
      applicantType = "automation";
    } else if (pathName === "/bilgiislem") {
      applicantType = "it";
    } else if (pathName === "/teknisyen") {
      applicantType = "technician";
    } else if (pathName === "/tobacco") {
      applicantType = "tobacco";
    } else if (pathName === "/marketing") {
      applicantType = "marketing";
    } else if (pathName === "/salesengineer") {
      applicantType = "salesengineer";
    } else if (pathName === "/insankaynaklari") {
      applicantType = "hr";
    } else if (pathName === "/finansmuhasebe") {
      applicantType = "financeaccounting";
    } else if (pathName === "/kalitesurec") {
      applicantType = "qualityprocess";
    } else {
      applicantType = "";
    }
    try {
      await axios.post(`${AppConfig.BaseUrl}/applicant/applicant-information`, {
        answers,
        applicantType,
      });
      setSuccess(true);
    } catch {
      setHasError(true);
      const model = new Survey.Model({ questions: questions });
      setMatrixRowErrorText(model, checkLanguage(pathName));
      model.data = answers;
      if (!sending && !success && model) {
        model.onValueChanged.add(function (survey, options) {
          if (options.name === "reference") {
            const referenceMatrix = survey.getQuestionByName("reference");

            referenceMatrix.visibleRows.forEach((row) => {
              const positionValue = row.getValue("reference_position");
              const contactValue = row.getValue("reference_contact");
              const referenceName = row.getValue("reference_name");

              // Eğer position veya contact alanları doluysa, name alanını zorunlu yap
              if (positionValue || contactValue) {
                row.getQuestionByColumnName("reference_name").isRequired = true;
              } else {
                row.getQuestionByColumnName(
                  "reference_name"
                ).isRequired = false;
              }
              if (referenceName) {
                row.getQuestionByColumnName(
                  "reference_contact"
                ).isRequired = true;
              } else {
                row.getQuestionByColumnName(
                  "reference_contact"
                ).isRequired = false;
              }
            });
          }
        });
      }
      setModel(model);
    }
    setSending(false);
  };

  const toggleModal = (message) => {
    setModalMessage(message);
    setIsOpen(true);
  };
  const handleCaptchaExpire = () => {
    setCaptchaVerified(false);
    setCaptchaExpired(true);
    toggleModal(
      languageCode === "TR"
        ? "CAPTCHA süresi doldu, lütfen tekrar doğrulama yapın."
        : "CAPTCHA has expired, please verify again."
    );
  };
  const handleCaptchaVerify = (token) => {
    setCaptchaVerified(!!token);
    setCaptchaExpired(false);
    model.setValue("captchaVerified", !!token);
    model.refresh();
  };
  return (
    <div className="customContent">
      {captchaExpired && (
        <div style={{ marginTop: "10px", fontSize: "14px", color: "red" }}>
          {languageCode === "TR"
            ? "CAPTCHA süresi doldu, lütfen tekrar doğrulama yapın."
            : "CAPTCHA has expired, please verify again."}
        </div>
      )}
      {sending && <Loading />}
      {hasError && (
        <div className="errorSendForm">
          {languageCode === "TR"
            ? "Bir hata oluştu, lütfen tekrar deneyin."
            : "An error occurred, please try again."}
        </div>
      )}
      {success && (
        <div className="successSendForm">
          {languageCode === "TR"
            ? "Form başarıyla gönderildi."
            : "The form has been successfully submitted."}
        </div>
      )}
      {fileValidating && (
        <div className="validation-loading">
          <Loading
            text={
              languageCode === "TR"
                ? "Dosya doğrulanıyor..."
                : "Validating file..."
            }
          />
        </div>
      )}
      {!sending && !success && model && (
        <Survey.Survey
          model={model}
          showCompletedPage={false}
          completeText={languageCode === "TR" ? "Formu Gönder" : "Submit"}
          onClearFiles={(sender, options) => {
            // Clear all files if no specific file is provided
            if (options.fileName == null) {
              setValidatedFiles([]);
              setTotalFiles(0);
              setTemporaryFilesStorage([]);
            } else {
              // Remove specific file
              setValidatedFiles((prev) =>
                prev.filter((file) => file.name !== options.fileName)
              );
              setTotalFiles((prev) => Math.max(0, prev - 1));
              setTemporaryFilesStorage((prev) =>
                prev.filter((file) => file.name !== options.fileName)
              );
            }
            options.callback("success");
          }}
          onUploadFiles={(sender, options) => {
            if (!captchaVerified) {
              return toggleModal(
                languageCode === "TR"
                  ? "Lütfen önce CAPTCHA doğrulamasını tamamlayın."
                  : "Please complete CAPTCHA verification first."
              );
            }
            if (validatedFiles.length + options.files.length > 4) {
              return toggleModal(
                languageCode === "TR"
                  ? "En fazla 4 dosya yükleyebilirsiniz."
                  : "You can upload up to 4 files."
              );
            }
            let isDuplicate = false;
            options.files.forEach((file) => {
              if (
                validatedFiles.some(
                  (existingFile) => existingFile.name === file.name
                )
              ) {
                isDuplicate = true;
              }
            });
            if (isDuplicate) {
              return toggleModal(
                languageCode === "TR"
                  ? "Aynı isimde dosya yükleyemezsiniz."
                  : "You cannot upload duplicate files."
              );
            }
            const oversizedFiles = options.files.filter(
              (file) => file.size > maxFileSize
            );
            if (oversizedFiles.length > 0) {
              return toggleModal(
                languageCode === "TR"
                  ? "Dosya boyutu en fazla 5MB olabilir."
                  : "File size cannot exceed 5MB."
              );
            }
            const invalidFiles = options.files.filter(
              (file) => file.type !== "application/pdf"
            );
            if (invalidFiles.length > 0) {
              return toggleModal(
                languageCode === "TR"
                  ? "Sadece PDF dosyaları yükleyebilirsiniz."
                  : "Only PDF files are allowed."
              );
            }
            let content = [];
            let validatedContent = [];

            const processFiles = async () => {
              for (const file of options.files) {
                const fileReader = new FileReader();
                try {
                  const base64Content = await new Promise((resolve, reject) => {
                    fileReader.onload = () => resolve(fileReader.result);
                    fileReader.onerror = reject;
                    fileReader.readAsDataURL(file);
                  });

                  const isValid = await validateFileOnBackend(file);
                  if (isValid) {
                    validatedContent.push({
                      name: file.name,
                      type: file.type,
                      content: base64Content,
                      file: file,
                    });
                  }
                } catch (error) {
                  console.error("Error processing file:", error);
                }
              }

              if (validatedContent.length > 0) {
                setValidatedFiles((prev) => [...prev, ...validatedContent]);
                setTotalFiles((prev) => prev + validatedContent.length);
                setTemporaryFilesStorage((prev) => [
                  ...prev,
                  ...validatedContent,
                ]);

                options.callback(
                  "success",
                  validatedContent.map((fileContent) => ({
                    file: fileContent.file,
                    content: fileContent.content,
                  }))
                );
              } else {
                toggleModal(
                  languageCode === "TR"
                    ? "Hiçbir dosya doğrulanamadı. Lütfen geçerli PDF dosyaları yükleyin."
                    : "No files were validated. Please upload valid PDF files."
                );
                options.callback("error");
              }
            };

            processFiles();
          }}
          onComplete={(result) => {
            if (!captchaVerified) {
              return toggleModal(
                languageCode === "TR"
                  ? "Lütfen önce CAPTCHA doğrulamasını tamamlayın."
                  : "Please complete CAPTCHA verification first."
              );
            }
            setSending(true);
            axiosPost(result.data);
          }}
          onTextMarkdown={(survey, options) => {
            options.html = converter.makeHtml(options.text);
          }}
          onAfterRenderQuestion={(survey, options) => {
            if (options.question.name === "uploadFiles") {
              let questionElement = options.htmlElement;
              questionElement.style.display = "contents";
            }
            if (options.question.getType() === "file") {
              const container = document.createElement("div");
              container.style.display = "flex";
              container.style.alignItems = "center";
              container.style.gap = "10px";
              container.style.backgroundColor = "white";
              options.htmlElement.appendChild(container);
              const fileInputContainer =
                options.htmlElement.querySelector(".sv_q_file");
              if (fileInputContainer) {
                container.appendChild(fileInputContainer);
              }
              const captchaContainer = document.createElement("div");
              container.insertBefore(captchaContainer, fileInputContainer);

              const captcha = (
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={AppConfig.SiteKey}
                  size="compact"
                  onChange={handleCaptchaVerify}
                  onExpired={handleCaptchaExpire}
                  hl={languageCode === "TR" ? "tr" : "en"}
                />
              );
              ReactDOM.render(captcha, captchaContainer);
            }
          }}
        />
      )}
      <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        className="mymodal"
        overlayClassName="myoverlay"
        closeTimeoutMS={0}
        shouldCloseOnOverlayClick={false}
      >
        <div>{modalMessage}</div>
        <button onClick={() => setIsOpen(false)}>
          {languageCode === "TR" ? "Kapat" : "Close"}
        </button>
      </Modal>
    </div>
  );
}

export default Content;
